<template>
  <div>

    <b-container fluid>
      <b-row>
        <b-col>
          <h2>Impressos</h2>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="3">
          <b-form @submit.prevent="filter" @reset.prevent="reset">
            <b-form-group
              description="Quer filtrar os ingressos 1 e 2? Use: 1,2"
              label="Filtrar por números:"
              label-for="filter-numbers">
              <b-form-input size="sm" id="filter-numbers" v-model="filters.numbers">
              </b-form-input>
            </b-form-group>

            <b-btn variant="success" type="submit">
              Filtrar
            </b-btn>

            <b-btn variant="info" type="reset">
              Limpar filtros
            </b-btn>
          </b-form>
        </b-col>
        <b-col cols="9">
          <b-card-group v-if="appliedFilters.length !== 0">
            <b-card
              no-body
              :header="tickets.length + ' ingresso(s) encontrados com os seguintes filtros:'">
              <b-list-group flush>
                <b-list-group-item v-for="(item, index) in appliedFilters" :key="index">
                  <strong>{{ item.filter }}:</strong> {{ item.values }}
                </b-list-group-item>
              </b-list-group>
            </b-card>
          </b-card-group>

          <table>
            <thead>
              <tr>
                <th>Número</th>
                <th>Lote</th>
                <th>Gerado em</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="ticket in tickets" :key="ticket.number">
                <td>{{ ticket.number }}</td>
                <td>{{ ticket.name }}</td>
                <td>
                  <span v-b-tooltip.hover :title="ticket.created_at | dateRelative">
                    {{ ticket.created_at | date }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import MaskedInput from 'vue-text-mask'

export default {
  name: 'DealerListTickets',
  components: {
    MaskedInput
  },
  data () {
    return {
      dealer: '',
      tickets: [],
      appliedFilters: [],
      filters: {
        limit: 0,
        numbers: ''
      }
    }
  },
  mounted () {
    this.dealer = this.$route.params.dealer
    this.getTickets('limit=10')
  },
  methods: {
    getTickets (filters) {
      let url = process.env.VUE_APP_URL_APP + '/b/dealers/' + this.dealer + '/tickets'

      if (filters !== '') {
        url = url + '?' + filters
      }

      return this.$http.get(url).then(res => {
        this.tickets = res.body.tickets
      }, err => {
        console.log(err)
      })
    },
    reset () {
      this.appliedFilters = []
      this.filters.numbers = ''
      this.getTickets('limit=10')
    },
    filter () {
      let filters = []
      this.appliedFilters = []

      if (this.filters.limit > 0) {
        filters.push('limit=' + this.filters.limit)
      }

      if (this.filters.numbers !== '') {
        filters.push('numbers=' + this.filters.numbers)

        let af = {
          filter: 'Números',
          values: this.filters.numbers
        }

        this.appliedFilters.push(af)
      }

      if (filters.length > 0) {
        filters = this.$_.join(filters, '&')
      }

      this.getTickets(filters)
    },
    reprint () {
      return false

      // --------------------------
      // Desativado temporariamente
      // --------------------------
      // let numbers = this.$_.reduce(this.tickets, (result, ticket) => {
      //   result.push(ticket.number)
      //   return result
      // }, [])

      // let msg = 'Estou ciente que um ingresso só é validado uma única vez por evento!'
      // if (!confirm(msg)) {
      //   return
      // }

      // let route = this.$router.resolve({
      //   name: 'DealerReRenderTickets',
      //   params: {
      //     dealer: this.dealer,
      //     numbers: this.$_.join(numbers, ',')
      //   }
      // })
      // window.open(route.href, '_blank')
    }
  }
}
</script>
